// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const ni: CountryValidator<"CU", ParsedPersonId> =
  createValidator("cu.ni", 45);

export default ni;
export const compact = ni.compact;
export const format = ni.format;
export const validate = ni.validate;
export const generate = (): string =>
  ni.generate?.() ??
  (() => {
    throw new Error(
      "Validator cu.ni cannot generate values",
    );
  })();
export const parse = ni.parse;
